export default function DeckUploadProgress({ value, label = 'Загрузка изображений' }) {
  if (!value || value.total <= 1) return null;
  const completed = Math.min(value.total, Math.max(0, value.done || 0));
  const percent = value.total > 0 ? Math.round((completed / value.total) * 100) : 0;
  return (
    <div className="deck-upload-progress-overlay" role="dialog" aria-modal="true" aria-label={label}>
      <div className="deck-upload-progress-card" role="status" aria-live="polite">
        <div className="deck-upload-progress-spinner" aria-hidden="true" />
        <strong>{label}</strong>
        <p>Обработано {completed} из {value.total} · {percent}%</p>
        <progress value={completed} max={value.total} aria-label="Прогресс загрузки" />
        {value.failed > 0 && <p className="form-error">Ошибок: {value.failed}</p>}
      </div>
    </div>
  );
}
